import React from "react";
import { connect } from "react-redux";
// import { Typography, withStyles, Grid } from "@material-ui/core";
import styles from "../../widgets/DashboardComponents/V3/UserTotalWidget/styles";
import { DisplayWidget } from "../../widgets/DashboardComponents/V3/UI/DisplayWidget";
import PersonIcon from "@material-ui/icons/Person";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import BuildIcon from "@material-ui/icons/Build";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import CommuteIcon from "@material-ui/icons/Commute";
import AddAlarmIcon from "@material-ui/icons/AddAlarm";
// import { hot } from "react-hot-loader";
import { Print as PrintIcon } from "@material-ui/icons";
import moment from "moment";
import { Divider } from "@material-ui/core";
import { StyledCard, StyledContent, StyledHeader } from "../../styles";
import {
    Typography,
    withStyles,
    MenuItem,
    Select,
    Grid,
    FormControl,
    Button,
    InputLabel,
} from "@material-ui/core";
import {
    getUsers,
    redirectTo,
    getFeatures,
    getMachines,
    getEquipments,
    getAlerts,
    setMonth,
    setYear,
    getReportTitles,
    getDepartments,
    getToolboxTitles,
    getToolbox,
    getReports,
    getJobpacks,
    getRecieptReports,
    getUserDeviceInfo,
    getAreas

} from "./actions";
import {
    selectFeature,
    getRequesting,
    canUpdate,
    canCreate,
    canDelete,
    selectDashDetails,
    selectFirstAiders,
    selectLastAccident,
    selectMonth,
    selectYear,
    selectVehicleAlerts,
    selectTitles,
    selectDepartmentsFilter,
    selectToolboxFilter,
    selectReportsForExcel,
    selectJobpacksFilter,
    selectReceiptReports,
    selectUserDeviceData,
    selectProfile

} from "./selectors";
import { Bar, Doughnut } from "react-chartjs-2";
import { Chart } from "react-google-charts";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import ReactToPrint from "react-to-print";
let openItem = 0; // open item count
let amber1 = 0;
let amber2 = 0;
let amber3 = 0;
let red = 0;
class CompanyAnalytics extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            uploadImageLocal: false,
            month: moment().format("MMM").toLowerCase(),
            year: moment().format("YYYY").toLowerCase(),
        };
        props.setMonth(moment().format("MMM").toLowerCase());
        props.setYear(moment().format("YYYY"));
        props.getUsers();
        props.getMachines();
        props.getEquipments();
        props.getAlerts();
        props.getReportTitles();
        props.getAreas();
        props.getDepartments();
        props.getToolbox();
        props.getToolboxTitles();
        props.getReports();
        props.getJobpacks(this.state.year);
        props.getRecieptReports();
        props.getUserDeviceInfo();
    }
    render() {
        const {
            details,
            firstAiders,
            lastAccident,
            alerts,
            titles,
            departments,
            toolbox,
            selectedReports,
            jobpacks,
            recieptReports,
            userDeviceInfo,
            userProfile
        } = this.props;
        let mail = userProfile.email;
        mail = String(mail)

        return (
            <StyledCard>
                <StyledHeader>
                    <Typography
                        variant="h5"
                        style={{ width: "50%", display: "inline" }}
                    >
                        Data Analysis Overview
                    </Typography>
                    <ReactToPrint
                        style={{}}
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                            document.title =
                                "Company Analytics - " +
                                moment().format("DD-MM-YYYY");
                        }}
                        onAfterPrint={() => {}}
                        trigger={() => (
                            <Button
                                style={{
                                    float: "right",
                                    color: "white",
                                    background: "#0188cc",
                                }}
                                color="primary"
                                variant="contained"
                                size="small"
                            >
                                <PrintIcon /> Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                </StyledHeader>
                <div
                    style={{ width: "100%" }}
                    ref={(el) => (this.componentRef = el)}
                >
                    <StyledContent>
                        <FormControl
                            style={{
                                width: "18%",
                                padding: 12,
                                borderRadius: 6,

                                margin: 12,
                                // background: "#eee",
                            }}
                        >
                            <InputLabel>Select Month</InputLabel>
                            <Select
                                value={this.state.month}
                                onChange={(event) => {
                                    this.setState({
                                        month: event.target.value,
                                    });
                                    this.props.setMonth(event.target.value);
                                }}
                            >
                                <MenuItem value="">Select Month</MenuItem>
                                <MenuItem value="jan">January</MenuItem>
                                <MenuItem value="feb">February</MenuItem>
                                <MenuItem value="mar">March</MenuItem>
                                <MenuItem value="apr">April</MenuItem>
                                <MenuItem value="may">May</MenuItem>
                                <MenuItem value="jun">June</MenuItem>
                                <MenuItem value="jul">July</MenuItem>
                                <MenuItem value="aug">August</MenuItem>
                                <MenuItem value="sep">September</MenuItem>
                                <MenuItem value="oct">October</MenuItem>
                                <MenuItem value="nov">November</MenuItem>
                                <MenuItem value="dec">December</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl
                            style={{
                                width: "18%",
                                padding: 12,
                                borderRadius: 6,

                                margin: 12,
                                // background: "#eee",
                            }}
                        >
                            <InputLabel>Select Year</InputLabel>
                            <Select
                                value={this.state.year}
                                onChange={(event) => {
                                    this.setState({
                                        year: event.target.value,
                                    });
                                    this.props.setYear(event.target.value);
                                }}
                            >
                                <MenuItem value="">Select Year</MenuItem>
                                <MenuItem value="2019">2019</MenuItem>
                                <MenuItem value="2020">2020</MenuItem>
                                <MenuItem value="2021">2021</MenuItem>
                            </Select>
                        </FormControl>
                        <br />

                        <Divider />
                        <br />
                        <Grid container spacing={3}>
                            {/* -----Users Grid-------  */}
                            <Grid item lg={4} md={4} sm={4} xs={4}>
                                <DisplayWidget
                                    color="white"
                                    background="#0188CC"
                                    Icon={PersonIcon}
                                    click={() => {
                                        this.props.redirectTo("/user-manager");
                                    }}
                                    primaryText={
                                        <Typography
                                            variant="subtitle2"
                                            style={{ color: "inherit" }}
                                        >
                                            <b>Total Registered Users</b>
                                        </Typography>
                                    }
                                    secondaryText={
                                        <Typography
                                            variant="title"
                                            style={{ color: "inherit" }}
                                        >
                                            {details.totalEmployees
                                                ? details.totalEmployees
                                                : 0}
                                        </Typography>
                                    }
                                />
                            </Grid>

                            {/* -----Machine Grid-------  */}

                            <Grid item lg={4} md={4} sm={4} xs={4}>
                                <DisplayWidget
                                    color="white"
                                    background="#cc4501"
                                    Icon={LocalShippingIcon}
                                    click={() => {
                                        this.props.redirectTo("/vehicle-list");
                                    }}
                                    primaryText={
                                        <Typography
                                            variant="subtitle2"
                                            style={{ color: "inherit" }}
                                        >
                                            <b>Total Registered Machines</b>
                                        </Typography>
                                    }
                                    secondaryText={
                                        <Typography
                                            variant="title"
                                            style={{ color: "inherit" }}
                                        >
                                            {details.totalMachines
                                                ? details.totalMachines
                                                : 0}
                                        </Typography>
                                    }
                                />
                            </Grid>
                            {/* ----QRS---- */}
                            <Grid item lg={4} md={4} sm={4} xs={4}>
                                <DisplayWidget
                                    color="white"
                                    background="#cc0188"
                                    Icon={BuildIcon}
                                    primaryText={
                                        <Typography
                                            variant="subtitle2"
                                            style={{ color: "inherit" }}
                                        >
                                            <b>Total registered equipment</b>
                                        </Typography>
                                    }
                                    secondaryText={
                                        <Typography
                                            variant="title"
                                            style={{ color: "inherit" }}
                                        >
                                            {details.totalQrs
                                                ? details.totalQrs
                                                : 0}
                                        </Typography>
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} width>
                            {/* -----SafetyAid Grid-------  */}
                            <Grid item lg={4} md={4} sm={4} xs={4}>
                                <DisplayWidget
                                    color="white"
                                    background="#88cc01"
                                    Icon={LocalHospitalIcon}
                                    // click={() => {
                                    //     this.props.redirectTo("/user-manager");
                                    // }}
                                    primaryText={
                                        <Typography
                                            variant="subtitle2"
                                            style={{ color: "inherit" }}
                                        >
                                            <b>Total registered first aides</b>
                                        </Typography>
                                    }
                                    secondaryText={
                                        <Typography
                                            variant="title"
                                            style={{ color: "inherit" }}
                                        >
                                            {firstAiders ? firstAiders : 0}
                                        </Typography>
                                    }
                                />
                            </Grid>

                            {/* -----Near miss Grid-------  */}

                            <Grid item lg={4} md={4} sm={4} xs={4}>
                                <DisplayWidget
                                    color="white"
                                    background="#cc0123"
                                    Icon={CommuteIcon}
                                    // click={() => {
                                    //     this.props.redirectTo("/vehicle-list");
                                    // }}
                                    primaryText={
                                        <Typography
                                            variant="subtitle2"
                                            style={{ color: "inherit" }}
                                        >
                                            <b>
                                                Registered last active Near miss
                                                report
                                            </b>
                                            <br />
                                        </Typography>
                                    }
                                    secondaryText={
                                        <Typography
                                            variant="title"
                                            style={{
                                                color: "inherit",
                                                fontSize: "16px",
                                            }}
                                        >
                                            {lastAccident ? lastAccident : 0}
                                        </Typography>
                                    }
                                />
                            </Grid>
                            {/* ----QRS---- */}
                            <Grid item lg={4} md={4} sm={4} xs={4}>
                                <DisplayWidget
                                    color="white"
                                    background="#ccab01"
                                    Icon={AddAlarmIcon}
                                    // click={() => {
                                    //     this.props.redirectTo("/vehicle-list");
                                    // }}
                                    primaryText={
                                        <Typography
                                            variant="subtitle2"
                                            style={{ color: "inherit" }}
                                        >
                                            <b>
                                                Vehicle Alerts (
                                                {this.state.month.toUpperCase()}
                                                )(
                                                {this.state.year})
                                            </b>
                                        </Typography>
                                    }
                                    secondaryText={
                                        <Typography
                                            variant="title"
                                            style={{ color: "inherit" }}
                                        >
                                            {alerts ? alerts : 0}
                                        </Typography>
                                    }
                                />
                            </Grid>
                        </Grid>
                        <br />
                        <br />
                        <Grid container layout={"row"} spacing={3}>
                            <br />
                            <br />
                            <Divider />
                            {/* -------Bar chart---------- */}
                            {toolbox === false ? (
                                ""
                            ) : (
                                <div
                                    style={{
                                        width: "550px",
                                        boxShadow:
                                            "-1px 1px 6px rgba(0, 0, 0, 0.5)",
                                        marginLeft: "68px",
                                    }}
                                >
                                    <Bar
                                        data={toolbox}
                                        height={300}
                                        width={400}
                                        options={{
                                            title: {
                                                display: true,
                                                text:
                                                    "Presented Tool Box Talks by Category",
                                                fontSize: 20,
                                            },
                                            legend: {
                                                display: false,
                                                position: "right",
                                            },
                                        }}
                                    />
                                </div>
                            )}
                            <p style={{ color: "white" }}>
                                {(openItem = 0)}
                                {(amber1 = 0)}
                                {(amber2 = 0)}
                                {(amber3 = 0)}
                                {(red = 0)}
                            </p>
                            {selectedReports &&
                                selectedReports.map((e) => {
                                    return e.map((f) => {
                                        return Object.values(f).map((k) => {
                                            return Object.values(k).map((l) => {
                                                return l.groups.map((n) => {
                                                    return n.items.map((m) => {
                                                        // if (m.item_status === "N/A")
                                                        //     closeItem = closeItem + 1;
                                                        // else if (m.item_status === "Green")
                                                        //     closeItem = closeItem + 1;
                                                        if (
                                                            m.item_status ===
                                                                "A1 Amber" ||
                                                            m.item_status ===
                                                                "A2 Amber" ||
                                                            m.item_status ===
                                                                "A3 Amber" ||
                                                            m.item_status ===
                                                                "Red"
                                                        ) {
                                                            if (
                                                                m.assigned_to !==
                                                                    "" &&
                                                                typeof m.item_close_date ===
                                                                    "undefined"
                                                            ) {
                                                                if (
                                                                    m.item_status ===
                                                                    "A1 Amber"
                                                                )
                                                                    amber1 =
                                                                        amber1 +
                                                                        1;
                                                                else if (
                                                                    m.item_status ===
                                                                    "A2 Amber"
                                                                )
                                                                    amber2 =
                                                                        amber2 +
                                                                        1;
                                                                else if (
                                                                    m.item_status ===
                                                                    "A3 Amber"
                                                                )
                                                                    amber3 =
                                                                        amber3 +
                                                                        1;
                                                                else
                                                                    red =
                                                                        red + 1;
                                                                openItem =
                                                                    openItem +
                                                                    1;
                                                            }
                                                        } else return null;
                                                        return null;
                                                    });
                                                });
                                            });
                                        });
                                    });
                                })}
                            <div
                                style={{
                                    boxShadow:
                                        "-1px 1px 6px rgba(0, 0, 0, 0.5)",
                                    float: "right",
                                    width: "36%",
                                    marginLeft: "95px",
                                    // height:
                                    //     this.infoDiv === undefined
                                    //         ? 0
                                    //         : this.infoDiv.offsetHeight -
                                    //           10,
                                }}
                            >
                                <b
                                    style={{
                                        marginLeft: "85px",
                                        fontSize: "20px",
                                    }}
                                >
                                    Total Open Inspection Items: {openItem}{" "}
                                </b>
                                <Chart
                                    // float="right"
                                    width={"410px"}
                                    height={"300px"}
                                    chartType="PieChart"
                                    loader={<div>Loading Chart</div>}
                                    data={[
                                        ["Color", "Count"],
                                        ["Amber 1", amber1],
                                        ["Amber 2", amber2],
                                        ["Amber 3", amber3],
                                        ["Red", red],
                                    ]}
                                    options={{
                                        slices: {
                                            0: { color: "#fcb040" },
                                            1: { color: "#f7941e" },
                                            2: { color: "#f1592a" },
                                            3: { color: "red" },
                                        },
                                    }}
                                    rootProps={{ "data-testid": "1" }}
                                />
                                <div>
                                    <FiberManualRecordIcon
                                        style={{
                                            color: "#fcb040",
                                            marginLeft: "32px",
                                        }}
                                    />{" "}
                                    <b>Amber 1</b>{" "}
                                    <span style={{ marginLeft: "200px" }}>
                                        {" "}
                                        {amber1}
                                    </span>
                                    <br />
                                    <FiberManualRecordIcon
                                        style={{
                                            color: "#f7941e",
                                            marginLeft: "32px",
                                        }}
                                    />{" "}
                                    <b>Amber 2</b>{" "}
                                    <span style={{ marginLeft: "197px" }}>
                                        {" "}
                                        {amber2}{" "}
                                    </span>{" "}
                                    <br />
                                    <FiberManualRecordIcon
                                        style={{
                                            color: "#f1592a",
                                            marginLeft: "32px",
                                        }}
                                    />{" "}
                                    <b>Amber 3</b>{" "}
                                    <span style={{ marginLeft: "197px" }}>
                                        {" "}
                                        {amber3}
                                        <br />{" "}
                                    </span>
                                    <FiberManualRecordIcon
                                        style={{
                                            color: "red",
                                            marginLeft: "32px",
                                        }}
                                    />{" "}
                                    <b>Red </b>{" "}
                                    <span style={{ marginLeft: "234px" }}>
                                        {" "}
                                        {red}{" "}
                                    </span>
                                </div>
                            </div>
                        </Grid>
                        <br />
                        <br />

                        {/* -----------------chart 2------------ */}
                        <br />
                        <br />
                        <Grid container layout={"row"} spacing={3}>
                            <br />
                            <br />
                            <Divider />
                            {/* -------Bar chart---------- */}
                            {departments === false ? (
                                ""
                            ) : (
                                <div
                                    style={{
                                        width: "500",
                                        boxShadow:
                                            "-1px 1px 6px rgba(0, 0, 0, 0.5)",
                                        marginLeft: "65px",
                                    }}
                                >
                                    <Bar
                                        data={departments}
                                        height={200}
                                        width={500}
                                        options={{
                                            title: {
                                                display: true,
                                                text:
                                                    "Report Count Per Department Per Month",
                                                fontSize: 20,
                                            },
                                            legend: {
                                                display: false,
                                                position: "right",
                                            },
                                        }}
                                    />
                                </div>
                            )}
                            {jobpacks === false ? (
                                ""
                            ) : (
                                <div
                                    style={{
                                        width: "500px",
                                        marginLeft: "150px",
                                        boxShadow:
                                            "-1px 1px 6px rgba(0, 0, 0, 0.5)",
                                    }}
                                >
                                    <Bar
                                        data={jobpacks}
                                        height={200}
                                        width={500}
                                        options={{
                                            title: {
                                                display: true,
                                                text:
                                                    "Total Jobpacks Created in Current Year",
                                                fontSize: 20,
                                            },
                                            legend: {
                                                display: false,
                                                position: "right",
                                            },
                                        }}
                                    />
                                </div>
                            )}
                        </Grid>
                        <br />
                        <br />
                        {/* -------Bar chart---------- */}
                        {titles === false ? (
                            ""
                        ) : (
                            <div
                                style={{
                                    width: "90%",
                                    boxShadow:
                                        "-1px 1px 6px rgba(0, 0, 0, 0.5)",
                                    marginLeft: "60px",
                                }}
                            >
                                <Bar
                                    data={titles}
                                    height={500}
                                    width={1100}
                                    options={{
                                        title: {
                                            display: true,
                                            text: "Report Per Month",
                                            fontSize: 20,
                                        },
                                        legend: {
                                            display: false,
                                            position: "right",
                                        },
                                    }}
                                />
                            </div>
                        )}
                        <br />
                        {recieptReports === false ? (
                            ""
                        ) : (
                            <div
                                style={{
                                    width: "90%",
                                    boxShadow:
                                        "-1px 1px 6px rgba(0, 0, 0, 0.5)",
                                    marginLeft: "60px",
                                }}
                            >
                                <Doughnut
                                    data={recieptReports}
                                    height={400}
                                    width={1100}
                                    options={{
                                        title: {
                                            display: true,
                                            text: "Reports Connection Status",
                                            fontSize: 20,
                                        },
                                        legend: {
                                            display: true,
                                            position: "top",
                                        },
                                    }}
                                />
                            </div>

                            )
                        }
                        <br />
                        <br />
                        {mail.includes("prowork")  ? (
                                <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                <div
                                       style={{
                                           width: "80%",
                                           boxShadow:
                                               "-1px 1px 6px rgba(0, 0, 0, 0.5)",
                                           marginLeft: "60px",
                                       }}
                                   >
                                       <Doughnut
                                           data={userDeviceInfo.versionChart}
                                           height={600}
                                           width={1100}
                                           options={{
                                               title: {
                                                   display: true,
                                                   text: "Breakdown of device OS versions",
                                                   fontSize: 20,
                                               },
                                               legend: {
                                                   display: true,
                                                   position: "top",
                                               },
                                           }}
                                       />
                                   </div>
                               </Grid>
                               <Grid item xs={12} sm={6}>
                               <div
                                       style={{
                                           width: "80%",
                                           boxShadow:
                                               "-1px 1px 6px rgba(0, 0, 0, 0.5)",
                                           marginLeft: "60px",
                                       }}
                                   >
                                       <Doughnut
                                           data={userDeviceInfo.brandChart}
                                           height={600}
                                           width={1100}
                                           options={{
                                               title: {
                                                   display: true,
                                                   text: "Breakdown of device brands",
                                                   fontSize: 20,
                                               },
                                               legend: {
                                                   display: true,
                                                   position: "top",
                                               },
                                           }}
                                       />
                                   </div>
                               </Grid>
                               <br />
                               <Grid item xs={12}>
                               <div
                                           style={{
                                               width: "70%",
                                               marginLeft: "150px",
                                               boxShadow:
                                                   "-1px 1px 6px rgba(0, 0, 0, 0.5)",
                                           }}
                                       >
                                           <Bar
                                               data={userDeviceInfo.modelChart}
                                               height={200}
                                               width={500}
                                               options={{
                                                   title: {
                                                       display: true,
                                                       text:
                                                           "Breakdown of device model",
                                                       fontSize: 20,
                                                   },
                                                   legend: {
                                                       display: false,
                                                       position: "right",
                                                   },
                                               }}
                                           />
       
                                       </div>
                               </Grid>
                               </Grid>
                            ) : (
                                <></>
                            )}
                        
                    </StyledContent>
                </div>
            </StyledCard>
        );
    }
}

export default connect(
    (store) => {
        return {
            features: selectFeature(store),
            requesting: getRequesting(store),
            canUpdate: canUpdate(store),
            canCreate: canCreate(store),
            canDelete: canDelete(store),
            details: selectDashDetails(store),
            firstAiders: selectFirstAiders(store),
            lastAccident: selectLastAccident(store),
            month: selectMonth(store),
            year: selectYear(store),
            alerts: selectVehicleAlerts(store),
            titles: selectTitles(store),
            departments: selectDepartmentsFilter(store),
            toolbox: selectToolboxFilter(store),
            selectedReports: selectReportsForExcel(store),
            jobpacks: selectJobpacksFilter(store),
            recieptReports: selectReceiptReports(store),
            userDeviceInfo: selectUserDeviceData(store),
            userProfile: selectProfile(store)

        };
    },
    {
        getFeatures,
        getUsers,
        redirectTo,
        getMachines,
        getEquipments,
        getAlerts,
        setMonth,
        setYear,
        getReportTitles,
        getDepartments,
        getToolboxTitles,
        getToolbox,
        getReports,
        getJobpacks,
        getRecieptReports,
        getAreas,
        getUserDeviceInfo,
        selectProfile

    }
)(withStyles(styles)(CompanyAnalytics));
